import * as React from "react";
import logosrc from "../../images/IND_PrimaryLogo.png";

const SvgIndependentLogoNext = (
  props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
) => <img alt="Independent Next" {...props} src={logosrc} />;

export default SvgIndependentLogoNext;
